<script>
import { pageCreationCompteProps, usePageCreationCompte } from "./mixin";
import InscriptionForm from "@/containers/compte-client/inscription-form";
import Container from "@/components/atoms/container";
import LazyImage from "@/components/atoms/lazy-image";
import GridCol from "@/components/molecules/grid/grid-col";
import GridRow from "@/components/molecules/grid/grid-row";

import customerAccountBgLogo from "@/assets/images/customer-account-bg-logo.jpg";

export default {
  components: {
    InscriptionForm,
    GridCol,
    GridRow,
    Container,
    LazyImage
  },
  props: {
    ...pageCreationCompteProps()
  },
  setup(props) {
    const { accountCreated } = usePageCreationCompte(props);
    return {
      accountCreated,
      customerAccountBgLogo
    };
  }
};
</script>

<template>
  <div
    id="content"
    role="main"
  >
    <Container class="u-bgcolor-white">
      <GridRow>
        <GridCol
          cols="3"
          no-gutter
        >
          <LazyImage
            :src="customerAccountBgLogo"
            alt="bandeau de confirmation"
            class="form-inscription-illustration"
            width="327"
            height="981"
          />
        </GridCol>
        <GridCol cols="9">
          <InscriptionForm
            form-class="u-mt-lg u-ml-xlg"
            @accountCreated="accountCreated"
            @showAuth="$showAuth()"
            @magasinSwitched="accountCreated"
          />
        </GridCol>
      </GridRow>
    </Container>
  </div>
</template>

<style lang="scss" scoped>
.form-inscription-illustration,
.form-inscription-illustration :deep(img) {
  position: sticky;
  top: 0;
  height: 100vh;
  -o-object-fit: cover;
  object-fit: cover;
  @include ie() {
    width: 100%;
    height: auto;
  }
}
</style>
